
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buscar",
      function () {
        return require("private-next-pages/buscar/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buscar"])
      });
    }
  